<template>
  <div>
    <!-- ----------------------------------------------- -->
    <!-- top cards -->
    <!-- ----------------------------------------------- -->
    <b-row>
      <b-col cols="12" md="6" lg="6">
        <b-card class="mb-4">
          <b-row>
            <b-col cols="3">
              <b-avatar size="4rem" class="ml-1" variant="primary" icon="journal-bookmark-fill">
              </b-avatar>
            </b-col>
            <b-col>
              <h3 class="card-title mb-1">{{ this.currentData.x_clase_ids.length }}</h3>
              <b-card-text>
                <h5>Clases</h5>
              </b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="6">
        <b-card class="mb-4">
          <b-row>
            <b-col cols="3">
              <b-avatar size="4rem" class="ml-1" variant="primary">
                <b-iconstack font-scale="2" title="Estudiantes">
                  <b-icon stacked variant="light" icon="person-fill" shift-h="-8"></b-icon>
                  <b-icon stacked variant="light" icon="person-fill" shift-h="0" shift-v="-4"></b-icon>
                  <b-icon stacked variant="light" icon="person-fill" shift-h="8"></b-icon>
                </b-iconstack>
              </b-avatar>
            </b-col>
            <b-col>
              <h3 class="card-title mb-1">{{ this.currentData.x_enrollment_ids.length }}</h3>
              <b-card-text>
                <h5>Inscripciones </h5>
              </b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- <b-col cols="12" md="6" lg="3">
        <b-card class="mb-4">
          <h4 class="card-title mb-1">50%</h4>
          <b-card-text class="mb-2">Yearly Sales</b-card-text>
          <b-progress variant="success" value="50" max="100"></b-progress>
        </b-card>
      </b-col> -->
      <!-- <b-col cols="12" md="6" lg="4">
        <b-card class="mb-4">
          <b-row>
            <b-col cols="3">
              <b-avatar class="ml-1" variant="primary" icon="journal-bookmark-fill">
              </b-avatar>
            </b-col>
            <b-col>
              <h4 class="card-title mb-1">{{ this.currentData.x_clase_ids.length }}</h4>
              <b-card-text> Clases </b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </b-col> -->
    </b-row>
    <!-- ----------------------------------------------- -->
    <!-- end top cards -->
    <!-- ----------------------------------------------- -->
    <b-row>
      <b-col cols="12" lg="8">
        <b-card class="mb-4">
          <h4 class="card-title">Histórico de Inscripciones</h4>
          <EnrollmentHistory />
        </b-card>
      </b-col>
      <!-- <b-col cols="12" lg="8">
        <b-card class="mb-4">
          <h4 class="card-title">Sales Summary</h4>
          <SalesSummary />
        </b-card>
      </b-col> -->
      <b-col cols="12" lg="4">
        <b-card class="mb-4">
          <h4 class="card-title">Estado de las Inscripciones {{ this.year.x_year }}</h4>
          <!-- <EnrollmentStatus :statusCounts="statusCounts" /> -->
          <EnrollmentStatus />
        </b-card>
      </b-col>
    </b-row>
    <!-- ----------------------------------------------- -->
    <!-- top selling products -->
    <!-- ----------------------------------------------- -->
    <b-card class="mb-4" no-body>
      <b-card-body>
        <h4 class="card-title">Últimas Órdenes Generadas</h4>
      </b-card-body>
      <b-table sticky-header striped hover no-border-collapse head-variant="light" style="min-height: 60vh"
        :items="salesOrder" :fields="invoiceFields" :busy="isBusy">
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando...</strong>
          </div>
        </template>
        <template #cell(order_id)="data">
          {{ data.item.order_id[1] }}
        </template>
        <template #cell(order_partner_id)="data">
          {{ data.item.order_partner_id[1] }}
        </template>
      </b-table>
    </b-card>
    <!-- ----------------------------------------------- -->
    <!-- end top selling products -->
    <!-- ----------------------------------------------- -->
    <!-- ----------------------------------------------- -->
    <!-- cards row -->
    <!-- ----------------------------------------------- -->
    <!-- <TopCards /> -->
    <!-- ----------------------------------------------- -->
    <!-- end cards row -->
    <!-- ----------------------------------------------- -->
  </div>
</template>

<script>

import EnrollmentHistory from './dashboard-components/EnrollmentHistory.vue'
import EnrollmentStatus from './dashboard-components/EnrollmentStatus.vue'
import { SaleOrderLinesService } from '@/services/sale.order.lines.service'
export default {
  name: 'adminDashboard',
  data: () => ({
    years: [],
    isBusy: true,
    invoiceFields: [{ key: 'order_id', label: 'ID Orden' }, { key: 'create_date', label: 'Fecha de Creación' }, { key: 'order_partner_id', label: 'Cliente' }, { key: 'display_name', label: 'Descripción' }],
    currentData: {},
    salesOrder: []
  }),
  components: {
    EnrollmentHistory,
    EnrollmentStatus
  },
  async created () {
    this.isBusy = true
    this.user = this.$store.state.user
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.currentData = this.years.filter((el) => el.x_year === this.year.x_year)[0]
    this.enrollmentsCurrent = this.currentData.x_enrollment_ids.length
  },
  async mounted () {
    try {
      this.salesOrder = await SaleOrderLinesService.list({}, ['display_name', 'create_date', 'order_id', 'price_unit', 'order_partner_id'])
      console.log('sale order---> ', this.salesOrder)
      this.isBusy = false
    } catch (error) {
      console.log(error)
    }
  }

}
</script>
